import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import { ReactiveVue } from '@skinsoft/reactive-vue';

import { DrawingTool, ShapeConfig } from '../toolbox';
import { getLabelCoordinates } from '../toolbox/label-coordinates-helper';

@Component({
    props: ['shapeConfig', 'index', 'drawingTool', 'labelConfig'],
    template: require('./annotation-drawing.html')
})
export class AnnotationDrawing extends ReactiveVue {

    public shapeConfig: ShapeConfig;
    public index: string;
    public drawingTool: DrawingTool;
    public labelConfig: any;

    public $refs: {
        label: any
    }

    private labelNode: any = null as any;

    private textConfig = {
        align: 'left',
        fill: 'black',
        fontFamily: 'Calibri',
        fontSize: 18,
        offsetX: 0,
        offsetY: 0,
        text: '1',
        x: 0,
        y: 0,
    }

    private textBgConfig = {
        fill: "white",
        radius: 15,
        stroke: "black",
        strokeWidth: 2,
        x: 0,
        y: 0,
    }

    public mounted() {
        this.labelNode = this.$refs.label.getNode();
    }

    public centerTextInLabel() {
        this.textConfig.offsetX = this.labelNode.width() / 2
        this.textConfig.offsetY = this.labelNode.height() / 2
    }

    @Watch('shapeConfig', { immediate: true, deep: true })
    public onShapeConfigChange() {

        // updating shape label
        const labelCenter = getLabelCoordinates(this.shapeConfig, this.textBgConfig.radius)

        this.textBgConfig.x = labelCenter.x
        this.textBgConfig.y = labelCenter.y

        this.textConfig.text = this.index;
        this.textConfig.x = labelCenter.x
        this.textConfig.y = labelCenter.y

        this.$nextTick(this.centerTextInLabel)
    }

    @Watch('labelConfig', { immediate: true, deep: true })
    private updateLabel() {
        this.textBgConfig.radius = this.labelConfig.radius
        this.textBgConfig.strokeWidth = this.labelConfig.strokeWidth
        this.textConfig.fontSize = this.labelConfig.fontSize;

        this.$nextTick(this.centerTextInLabel)
    }

}